import { render, staticRenderFns } from "./NewSearch.vue?vue&type=template&id=b5fd7090&scoped=true"
import script from "./NewSearch.vue?vue&type=script&lang=js"
export * from "./NewSearch.vue?vue&type=script&lang=js"
import style0 from "./NewSearch.vue?vue&type=style&index=0&id=b5fd7090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fd7090",
  null
  
)

export default component.exports